export default function WhyManagersSellWrong() {
  const chain = [
    { step: '1', text: 'Менеджер сразу начинает рассказывать о продукте — не поняв, с каким запросом пришёл клиент' },
    { step: '2', text: 'Не выявил критерии выбора — клиент сравнивает не то, что ему нужно, а что предложили' },
    { step: '3', text: 'Не узнал скрытые потребности — то, о чём клиент сам не говорит, но что важнее всего' },
    { step: '4', text: 'Не выяснил боли — клиент не чувствует, что его проблему действительно понимают' },
    { step: '5', text: 'Не выяснил последствия проблемы — менеджер не показал цену бездействия' },
    { step: '6', text: 'Не узнал мотив покупки — непонятно, почему клиенту это нужно именно сейчас' },
    { step: '7', text: 'Не понял, кто принимает решение — разговор идёт не с тем человеком' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему менеджеры продают не то
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Большинство менеджеров слышат запрос клиента, но не понимают его настоящую потребность. Вот как это происходит шаг за шагом — и почему сделка теряется на этапе диагностики.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-5 mb-12">
          {chain.map((item, i) => (
            <div key={i} className="flex items-start gap-4 group">
              <div className="w-9 h-9 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-red-200 transition-colors">
                <span className="text-red-600 font-bold text-sm">{item.step}</span>
              </div>
              <p className="text-base text-gray-700 leading-relaxed pt-1">{item.text}</p>
            </div>
          ))}
          <div className="flex items-start gap-4">
            <div className="w-9 h-9 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-close-line text-white text-sm"></i>
            </div>
            <div className="pt-1">
              <p className="text-base font-bold text-red-600 leading-relaxed">
                Итог: клиент говорит «Мы подумаем»
              </p>
              <p className="text-sm text-gray-500 mt-1">А на самом деле — менеджер так и не понял, что нужно клиенту.</p>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-lightbulb-line text-3xl text-white"></i>
          </div>
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            Презентация без диагностики — это предложение решения для несуществующей задачи. А потом менеджер удивляется, почему клиент ушёл.
          </p>
        </div>
      </div>
    </section>
  );
}